import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { NDDGridExportService } from '@ndk/ng-grid';
import { NDDTranslationService } from '@ndk/ng-translation';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { ICoreConfigInternal } from '@core/core.config.model';
import { LoggerService } from '@core/logger/logger.service';

import { IGridExportCommand } from './grid-export.model';

@Injectable()
export class GridExportService extends NDDGridExportService {
    private apiUrl: string;

    constructor(
        @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal,
        private http: HttpClient,
        private loggerService: LoggerService,
        private translationService: NDDTranslationService,
    ) {
        super();
        this.apiUrl = `${ config.apiEndpoint }api/export-data-grid`;
    }

    public getUrl(originalUri: string, exportType: string): string {
        return originalUri;
    }

    public exportCsv(command: IGridExportCommand): Observable<boolean> {
        return this.http.post<boolean>(this.apiUrl, command)
            .pipe(
                tap(() => {
                    this.loggerService.success(true, [this.translationService.instant('360ExportSucess')]);
                }),
                catchError((reason: boolean) => {
                    this.loggerService.error(true, [this.translationService.instant('360ExportFailed')]);

                    return observableThrowError(reason);
                }),
            );
    }
}
